<template>
  <div :class="classes" @click.prevent="$emit('click', category)">
    <div class="image-navigator-folder__icon">
      <v-icon :color="iconColor">folder</v-icon>
    </div>
    <div class="image-navigator-folder__name">
      <div>{{ category.name }}</div>
    </div>
    <div v-if="!hideActions" class="image-navigator-folder__settings">
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" :color="iconColor" size="16">settings</v-icon>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in items"
            :key="index"
            @click="() => onChooseAction(item)"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <div class="image-navigator-folder__arrow">
      <v-icon :color="iconColor" size="10">arrow_forward_ios</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    category: Object,
    selected: Boolean,
    imageCount: Number,
    hideActions: Boolean,
  },
  computed: {
    classes() {
      return {
        "image-navigator-folder": true,
        "image-navigator-folder--selected": this.selected,
      };
    },
    iconColor() {
      return this.selected ? "black" : "grey";
    },
    items() {
      return [
        { type: "edit", title: "Editar" },
        { type: "delete", title: "Deletar" },
      ].filter((item) => {
        if (this.imageCount > 0) {
          return item.type !== "delete";
        }
        return true;
      });
    },
  },
  methods: {
    onChooseAction(item) {
      this.$emit(item.type, this.category);
    },
  },
};
</script>

<style lang="scss" scoped>
.image-navigator-folder {
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
  padding: 0 10px;
  height: 30px;
  position: relative;
  &:hover {
    background: #eee;
    .image-navigator-folder__settings {
      display: flex;
    }
  }
  &--selected {
    background: #fec402;
    color: black;
    &:hover {
      background: #fec402;
      color: black;
    }
    .image-navigator-folder__settings {
      display: flex;
    }
  }
  &__icon {
    margin-right: 5px;
    display: flex;
    flex-shrink: 0;
  }
  &__name {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__settings {
    flex-shrink: 0;
    display: flex;
    margin: 0 10px;
    display: none;
  }
  &__arrow {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
